// extracted by mini-css-extract-plugin
export default {"ladderPrice":"EWx3sFaieuFyj0o6m7bn"};